import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    redirect:'/login',
    component:resolve => require(["@/views/home"], resolve),
    meta:{title:"首页"},
    children:[
      {
        path: 'account-no',
        name: 'account-no',
        meta: {
          title: '账号',
          icon: 'user',
        },
        component: resolve => require(["@/views/index.vue"], resolve),
        children:[
          {
            path: 'sub-account-no',
            name: 'sub-account-no',
            meta: {
              title: '账号管理',
            },
            component: resolve => require(["@/views/account/index.vue"], resolve),
          },
        ]
      },{
        path: 'category',
        name: 'category',
        meta: {
          title: '类目',
          icon: 'class',
        },
        component: resolve => require(["@/views/index.vue"], resolve),
        children:[
          {
            path: 'category-manage',
            name: 'category-manage',
            meta: {
              title: '类目管理',
            },
            component: resolve => require(["@/views/category/index.vue"], resolve),
            children:[
              {
                path: 'sub-category',
                name:'sub-category',
                meta: {
                  noMenu:true,
                },
                component: resolve => require(["@/views/category/subCategory.vue"], resolve),
              },
            ]
          },
          
        ]
      },{
        path: 'product',
        name: 'product',
        meta: {
          title: '商品',
          icon: 'product',
        },
        component: resolve => require(["@/views/index.vue"], resolve),
        children:[
          {
            path: 'product-manage',
            name: 'product-manage',
            meta: {
              title: '商品管理',
            },
            component: resolve => require(["@/views/product/manage"], resolve),
            children:[
                {
                  path: 'category-authorize',
                  name: 'category-authorize',
                  meta: {
                    title: '类目授权渠道商',
                  },
                  component: resolve => require(["@/views/product/manage/batchAudit.vue"], resolve),
                },
                {
                  path: 'product-detail',
                  name: 'product-detail',
                  meta: {
                    title: '详情',
                  },
                  component: resolve => require(["@/views/product/manage/detail.vue"], resolve),
                },
              ]
          },
          {
            path: 'product-specification',
            name: 'product-specification',
            meta: {
              title: '商品规格',
            },
            component: resolve => require(["@/views/product/specification"], resolve),
            children:[
              {
                path: 'spec-detail',
                name: 'spec-detail',
                meta: {
                  title: '详情',
                },
                component: resolve => require(["@/views/product/specification/detail"], resolve),
              }
            ]
          },
          {
            path: 'price-rules',
            name: 'price-rules',
            meta: {
              title: '渠道价规则',
            },
            component: resolve => require(["@/views/product/priceRules.vue"], resolve),
          },
        ]
      },
      {
        path: 'order',
        name: 'order',
        meta: {
          title: '订单',
          icon: 'order',
        },
        component: resolve => require(["@/views/index.vue"], resolve),
        children:[
          {
            path: 'order-manage',
            name: 'order-manage',
            meta: { title: '订单管理'},
            component: resolve => require(["@/views/order/index.vue"], resolve),
            children:[
              {
                path: 'order-detail',
                name: 'order-detail',
                meta: {
                  title: '订单详情',
                },
                component: resolve => require(["@/components/OrderDetail.vue"], resolve),
              },
            ]
          },
        ]
      },
      {
        path: 'account',
        name: 'account',
        meta: {
          title: '账户',
          icon: 'account',
        },
        component: resolve => require(["@/views/index.vue"], resolve),
        children:[
          {
            path: 'channel-account',
            name: 'channel-account',
            meta: {
              title: '渠道商资金账户',
            },
            component: resolve => require(["@/views/capital/channel/index.vue"], resolve),
            children:[
              {
                path: 'channel-capital',
                name: 'channel-capital',
                meta:{
                  keepAlive: false //此页面需要缓存
                },
                component: resolve => require(["@/views/capital/channel/components/capitalDetail.vue"], resolve),
              },
              {
                path: 'order-channel',
                name: 'order-channel',
                component: resolve => require(["@/components/OrderDetail.vue"], resolve),
              }
            ]
          },
          {
            path: 'supplier-account',
            name: 'supplier-account',
            meta: {
              title: '供应商资金账户',
            },
            component: resolve => require(["@/views/capital/supplier/index.vue"], resolve),
            children:[
              {
                path: 'supplier-advance',
                name: 'supplier-advance',
                component: resolve => require(["@/views/capital/supplier/advancePaly/supplierAdvance.vue"], resolve),
              },{
                path: 'order-advance',
                name: 'order-advance',
                meta:{
                  keepAlive: false //此页面需要缓存
                },
                component: resolve => require(["@/components/OrderDetail.vue"], resolve),
              },{
                path: 'order-after',
                name: 'order-after',
                meta:{
                  keepAlive: false //此页面需要缓存
                },
                component: resolve => require(["@/components/OrderDetail.vue"], resolve),
              },{
                path: 'order-settlement',
                name: 'order-settlement',
                component: resolve => require(["@/views/capital/supplier/afterPaly/orderSettlement.vue"], resolve),
              },{
                path: 'settlement-detail',
                name: 'settlement-detail',
                meta:{
                  keepAlive: false //此页面需要缓存
                },
                component: resolve => require(["@/views/capital/supplier/afterPaly/settlementDetail.vue"], resolve),
              },
            ]
          },
        ]
      },
      {
        path: 'message',
        name: 'message',
        meta: {
          title: '消息中心',
          unShow:true,
        },
        component: resolve => require(["@/views/message/index.vue"], resolve),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login'],resolve)
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from ,next) => {
  next()
})
export default router
